import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage'; // Importando o Storage

// Configurações do Firebase (substitua pelos seus dados)
const firebaseConfig = {
    apiKey: "AIzaSyBAvzmp0xg4u8iMbJWczDJGY8EQ2Wjqr3Q",
    authDomain: "aapgis.firebaseapp.com",
    projectId: "aapgis",
    storageBucket: "aapgis.firebasestorage.app",
    messagingSenderId: "270138877531",
    appId: "1:270138877531:web:ad37e80c994734f238c17e",
    measurementId: "G-4P97895FG2"
  };

// Inicializando o Firebase
const app = initializeApp(firebaseConfig);
// Exportando instâncias do Firebase Auth e Realtime Database
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app); // Firebase Storage